module.exports = __webpack_public_path__ + "img/23@2x.0d037a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/23@2x.png
// module id = wcEC
// module chunks = 0